import { render, staticRenderFns } from "./noBgClockapp.vue?vue&type=template&id=0ed0f268&scoped=true"
import script from "./noBgClockapp.vue?vue&type=script&lang=js"
export * from "./noBgClockapp.vue?vue&type=script&lang=js"
import style0 from "./noBgClockapp.vue?vue&type=style&index=0&id=0ed0f268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed0f268",
  null
  
)

export default component.exports